import React from "react";
import StepsIcon from '../assets/icons/steps.svg';
import CaloriesIcon from '../assets/icons/calories.svg';
import { t } from "../multi-language/multi-lang.service";
export default function ChartBox(_a) {
    var type = _a.type, configurations = _a.configurations, isPdf = _a.isPdf;
    var wellness = ['calories', 'steps'];
    var wellnessImages = {
        steps: StepsIcon,
        calories: CaloriesIcon,
    };
    var newPageCharts = ['sleep'];
    var isNewPage = function (type) {
        if (newPageCharts.includes(type))
            return 'page-break';
        return '';
    };
    var getWellnessTemplate = function () {
        //render wellness head just once
        if (!configurations[type]
            || (type !== 'calories' && configurations['calories'])) {
            return;
        }
        return (React.createElement("div", { id: "wellness-charts", className: 'card page-break' },
            React.createElement("div", { className: "bg-transparent card-header" },
                React.createElement("div", { className: "row header-card" },
                    React.createElement("div", { className: "col-xs-auto" }, t('measurements.wellness')))),
            React.createElement("div", { className: "wellness" },
                React.createElement("div", { className: "red-color" }),
                React.createElement("div", { className: "blue-color" }),
                React.createElement("div", { className: "green-color" }),
                React.createElement("div", { className: "yellow-color" }))));
    };
    return (React.createElement(React.Fragment, null, wellness.includes(type) && configurations[type] ? //wellness charts (steps and callories)
        React.createElement("div", { className: 'pdf-cut-guard' },
            getWellnessTemplate(),
            React.createElement(React.Fragment, null,
                React.createElement("div", { className: "title-icon-container" },
                    React.createElement("img", { width: 40, src: wellnessImages[type], alt: 'wellness icon' }),
                    React.createElement("div", { className: "title text-capitalize" }, t("charts.".concat(type, ".title")))),
                React.createElement("div", { className: "line-divide" })),
            React.createElement("div", { className: "card-body" },
                React.createElement("div", { className: "".concat(type, "-chart ltr"), style: { width: '100%' } }))) : (configurations[type.replace('-', '_').toLowerCase()]) && //all other charts
        React.createElement("div", { className: "card wrap-".concat(type, " ").concat(isNewPage(type)) },
            React.createElement("div", { className: "bg-transparent card-header" }, type === 'hrv_lfhf' && configurations['hrv_pr'] ?
                ''
                :
                    React.createElement("div", { className: "row header-card" },
                        React.createElement("div", { className: "col-xs-auto text-capitalize" }, t("charts.".concat(type, ".title"))))),
            React.createElement("div", { className: "card-body ltr" },
                React.createElement("div", { className: "".concat(type, "-chart pb-2"), style: { width: '100%' } })))));
}
//# sourceMappingURL=cart-box.js.map